/*
 * File: \index.js
 * File Created: 2022-03-30 14:52:42
 * Author: Li Haifeng
 * -----
 * Last Modified: 2023-04-13 16:55:26
 * Modified By: Ocean Li ���
 */
import native from "./native.js";
import nativeWrapper from "./nativeWrapper.js";
import { tools } from "@midea/mx-cli-module-core";

const { configAPI, error } = tools;

export default class MxNative {
  constructor(config) {
    try {
      let conf = new configAPI(config);
      let na = new native(conf);
      let cf = conf.getConf();
      if (na && cf && cf.nativeApis && cf.nativeApis.length > 0) {
        na.addApis(cf.nativeApis)
      }
      na = new nativeWrapper(na)
    } catch (e) {
      error(3002, e);
    }
  }
}
